import { useScrollReveal } from "../../hooks/useScrollReveal";

export const WhoWeWorkWith = () => {
  const [headerRef, headerVis] = useScrollReveal();
  const [c1Ref, c1Vis] = useScrollReveal(0.1);
  const [c2Ref, c2Vis] = useScrollReveal(0.1);
  const [c3Ref, c3Vis] = useScrollReveal(0.1);
  const [noteRef, noteVis] = useScrollReveal();

  return (
    <section
      id="who-we-work-with"
      data-testid="who-we-work-with-section"
      className="bg-[#F8FAFC] py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div ref={headerRef} className={`reveal ${headerVis ? 'visible' : ''}`}>
          <div className="editorial-rule mb-6" />
          <h2
            data-testid="who-we-work-with-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(36px,5vw,68px)] tracking-[-0.03em] text-[#0F172A] leading-[1.0] max-w-[700px]"
          >
            We cap the number of accounts we take on. Here's who fits.
          </h2>
        </div>

        {/* Cards */}
        <div className="mt-16 md:mt-24 grid md:grid-cols-3 gap-6 md:gap-8">
          {/* Education */}
          <div
            ref={c1Ref}
            data-testid="icp-education-card"
            className={`card-lift bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden reveal ${c1Vis ? 'visible' : ''}`}
          >
            <div className="h-1.5 bg-[#0064E0]" />
            <div className="p-8 md:p-10">
              <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-[#0064E0] mb-6 block">
                Education
              </span>
              <h3
                data-testid="icp-education-label"
                className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[26px] text-[#0F172A] leading-[1.1] tracking-[-0.01em]"
              >
                Online education businesses
              </h3>
              <p className="mt-5 text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
                Course creators, coaches, and info-product founders whose
                funnel and paid traffic need to work together. We tighten
                the offer-to-checkout path and scale the spend behind it.
              </p>
            </div>
          </div>

          {/* Ecommerce */}
          <div
            ref={c2Ref}
            data-testid="icp-ecommerce-card"
            className={`card-lift bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden reveal ${c2Vis ? 'visible' : ''}`}
            style={{ transitionDelay: '100ms' }}
          >
            <div className="h-1.5 bg-[#0064E0]" />
            <div className="p-8 md:p-10">
              <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-[#0064E0] mb-6 block">
                Ecommerce
              </span>
              <h3
                data-testid="icp-ecommerce-label"
                className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[26px] text-[#0F172A] leading-[1.1] tracking-[-0.01em]"
              >
                Ecommerce brands (DTC)
              </h3>
              <p className="mt-5 text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
                DTC brands that have hit a performance ceiling. We overhaul
                account structure, speed up creative testing, and get spend
                profitable again.
              </p>
            </div>
          </div>

          {/* Service businesses */}
          <div
            ref={c3Ref}
            data-testid="icp-service-card"
            className={`card-lift bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden reveal ${c3Vis ? 'visible' : ''}`}
            style={{ transitionDelay: '200ms' }}
          >
            <div className="h-1.5 bg-[#0064E0]" />
            <div className="p-8 md:p-10">
              <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-[#0064E0] mb-6 block">
                Services
              </span>
              <h3
                data-testid="icp-service-label"
                className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[26px] text-[#0F172A] leading-[1.1] tracking-[-0.01em]"
              >
                Service businesses
              </h3>
              <p className="mt-5 text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
                Businesses that grow by booked jobs and repeat customers, not
                online carts. We turn ad spend into qualified leads and
                booked calls, then fix the path from click to contact
                so fewer of them slip away.
              </p>
            </div>
          </div>
        </div>

        {/* Qualification Note */}
        <div
          ref={noteRef}
          data-testid="qualification-note"
          className={`mt-14 md:mt-20 reveal ${noteVis ? 'visible' : ''}`}
        >
          <div className="max-w-[800px] border-l-[3px] border-[#0064E0] pl-8">
            <p className="text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
              We work with a small number of accounts at any time. If you
              need a full-service agency with a
              ten-person team, we're probably not the right fit. We'll
              tell you that on the call.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
